import { InjectionToken } from './injection-token.js';

/**
 * Dependency Injection Registry
 */
export class Registry {

    // holding instances/values by key
    private static elements: Map<string, unknown> = new Map();

    // with private constructor prevent class from instantiating
    private constructor() { }

    /**
     * Registers a given object to a given key.
     * Each key can be registered only once.
     *
     * @param key a given key
     * @param value a given object to store
     */
    static register<T>(token: InjectionToken<T>, value: T): void {
        const key = token.toString();
        if (Registry.elements.has(key)) throw new Error(`Registry: key ${key} already registered`);
        Registry.elements.set(key, value);
    }

    /**
     * Returns an object for an given key if registerd before.
     * Throws an error, if the key was not found.
     *
     * @param key a given key
     * @returns an object
     */
    static lookup<T>(token: InjectionToken<T>): T {
        const key = token.toString();
        const value = Registry.elements.get(key);
        if (!value) throw new Error(`Registry: key ${key} not found`);
        return value as T;
    }

    static entries(): Iterable<[string, unknown]> {
        return this.elements.entries();
    }
}
